<script setup lang="ts">
import { Participant } from '@collector/sportsapi-client-legacy'

import PitchParticipantName from '../../PitchParticipantName.vue'
import PitchBlockedIncidentOverlay from './PitchBlockedIncidentOverlay.vue'
import PitchParticipantIncidents from './PitchParticipantIncidents.vue'
import PitchParticipantIncidentsTeamSide from './PitchParticipantIncidentsTeamSide.vue'

interface Props {
  participant: Participant
  reversed?: boolean
  incidentsClass?: string
}

defineProps<Props>()
</script>

<template>
  <div class="relative">
    <PitchBlockedIncidentOverlay withText />

    <PitchParticipantIncidentsTeamSide
      class="flex h-full flex-col gap-y-1 overflow-hidden p-1"
      :class="[
        {
          'pr-[clamp(0.5rem,2vw,1rem)]': !reversed,
          'pl-[clamp(0.5rem,2vw,1rem)]': reversed,
        },
        incidentsClass,
      ]"
      :participant
    >
      <PitchParticipantName :participant />
      <PitchParticipantIncidents
        :participant
        :reversed
      />
    </PitchParticipantIncidentsTeamSide>
  </div>
</template>
